// src/components/PullQuoteCard.js
// Shared pull-quote card shell, used identically by StationEntry and AugustToday so their
// ritual/quote cards render from one JSX source instead of two separately-maintained copies
// that can drift apart. Renders the exact .station-entry-quote* classes both screens' CSS
// already targets (App.css base + cities.css's august-only text-style override) — no new CSS.
//
// Structural guard: this component is the italic/bordered quote-card treatment for SHORT
// quote strings only — the same <=12-word isHandwrittenLength convention the typography rule
// already uses everywhere else to tell "short quote" apart from "reading content". This is not
// hypothetical: AugustToday.js briefly passed its full ritual paragraph in here (production
// rendered the entire paragraph in italic script inside the bordered card). Rather than trust
// every future caller to only ever pass a short string, long text is rendered as plain text
// instead of the quote card — a caller bug becomes visibly plain text, never a wall of italic
// script standing in for body copy.
import React from 'react'
import { isHandwrittenLength } from '../utils/promptLength'

export default function PullQuoteCard({ text, mark = '❝' }) {
  if (!isHandwrittenLength(text)) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('PullQuoteCard received long text (>12 words) — rendering as plain text instead of the quote card. This component is for short quote strings only.', text)
    }
    return <p className="station-entry-intro">{text}</p>
  }

  return (
    <div className="station-entry-quote">
      <span className="station-entry-quote-mark">{mark}</span>
      <span className="station-entry-quote-text">{text}</span>
    </div>
  )
}
